<template>
<h4 class="fw-bold">Bandeiras aceitas</h4>
<img src="@/assets/img/card_brands.png" alt="">
</template>
<script lang="ts" setup>
</script>
<style scoped>
img {
    height: 20px !important;
}
</style>